export const RespCode = {
  Success: 0,
};

export const ErrorCode = {
  /** 接口返回错误 */
  Wrong: -9999, // 前端定义code
  /** 数据丢失，引导重新登录 */
  Refresh: -10000,
  /** 过期 */
  Expired: 2000002,
  /** 已到最大值 */
  Total: 2000004,
  /** 旧版理赔过 */
  HasOldClaim: 2000005,
  // /** 查询到不止一个保单 */
  // Multiple: 2000006,
  /**  保单coverd_item为空 */
  CoverdItemEmpty: 2000007,
  /** 请求错误 */
  WrongRequest: 300006,
  /** 保单被取消 */
  Cancelled: 2000003,
  Nothing: 2000001, // 无保单
  PolicyNotActive: 2000008,
  Unfulfilled: 2000010,
  Unauthorized: 200002,
  HasDelay: -8888, // 前端定义code 针对dhgate delay 同一个包裹申请过后不允许重复申请
  Conflict: 2000009, // 互斥提示code
  Instant: -7777, // 前端定义code 用于shopline -- 48小时之内不能报案code
  SpecialCodeForCTBids: -6666, // 前端定义code，用于ctbids，29天以后没有tracking信息，则提示报错信息
  Blacklist: 2000011,
};

export const ApiPath = {
  AgentApi: '/gateway/agent-service/api/',
};

export const ApiUri = {
  Upload: 'upload-files',
};

export const RequestMethod = {
  Post: 'POST',
  Get: 'GET',
};

// 根据code提示不同报错话术
export const ErrorCodeToSpecialText = [ErrorCode.Expired, ErrorCode.Total, ErrorCode.Cancelled, ErrorCode.HasOldClaim, ErrorCode.CoverdItemEmpty, ErrorCode.Unfulfilled, ErrorCode.PolicyNotActive, ErrorCode.Unauthorized, ErrorCode.Conflict, ErrorCode.Blacklist];
